import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Checkbox from '@material-ui/core/Checkbox'
import classNames from 'classnames'

import { ValidatorForm } from 'react-material-ui-form-validator'

import { connect } from 'react-redux'
import compose from 'recompose/compose'
import moment from 'moment'

import { updatePatient } from '../actions'

import '../styles/index.scss'
import '../styles/patientProfile.scss'

const styles = theme => (null)

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.currentUser,
    currentPatient: state.currentPatient
  }
}

const mapDispatchToProps = {
  updatePatient
}

class PatientProfile extends React.Component {
  state = {
    firstName: '',
    lastName: '',
    dob: '',
    patientId: '',
    _id: this.props.patientId,
    editing: false,
    phone: '',
    email: '',
    nickname: '',
    gender: '',
    prevPatient: null,
    emailPermission: {
      rideComplete: true,
      evalComplete: true
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.currentPatient !== this.props.currentPatient) {
      this.refreshPatientInfo()
    }
  }

  componentDidMount () {
    this.refreshPatientInfo()
  }

  refreshPatientInfo () {
    // Check for all available fields and replace the state if they're there
    let patient = this.props.currentPatient

    if (patient.phone) {
      this.setState({ phone: patient.phone })
    }
    if (patient.email) {
      this.setState({ email: patient.email })
    }
    if (patient.nickname) {
      this.setState({ nickname: patient.nickname })
    }
    if (patient.gender) {
      this.setState({ gender: patient.gender })
    }
    if (patient.dob) {
      this.setState({ dob: patient.dob })
    }
    if (patient.emailPermission) {
      this.setState({ emailPermission: patient.emailPermission })
    }
    if (patient.name) {
      if (patient.name.given) {
        this.setState({ firstName: patient.name.given })
      }
      if (patient.name.family) {
        this.setState({ lastName: patient.name.family })
      }
    }
    if (patient.patientID) {
      this.setState({ patientId: patient.patientID })
    }
  }

  editProfile = () => {
    this.setState({
      editing: true,
      prevPatient: {
        firstName: this.props.currentPatient.name.given,
        lastName: this.props.currentPatient.name.family,
        dob: this.props.currentPatient.dob,
        patientId: this.props.currentPatient.patientID,
        _id: this.props.currentPatient._id,
        phone: this.state.phone,
        email: this.state.email,
        nickname: this.state.nickname,
        gender: this.state.gender
      }
    })
  }

  handleChange (event) {
    this.editProfile()

    let name = event.target.name
    let emailPermission = this.state.emailPermission

    if (name === 'rideComplete' || name === 'evalComplete') {
      emailPermission[name] = event.target.checked
      this.setState({ emailPermission: emailPermission })
    }
    else {
      this.setState({ [name]: event.target.value })
    }
  }

  cancelEdit = () => {
    let emailPermission
    if (this.props.currentPatient.emailPermission) {
      emailPermission = this.props.currentPatient.emailPermission
    }
    else {
      emailPermission = {
        rideComplete: true,
        evalComplete: true
      }
    }

    this.setState({
      editing: false,
      firstName: this.props.currentPatient.name.given,
      lastName: this.props.currentPatient.name.family,
      dob: this.props.currentPatient.dob,
      patientId: this.props.currentPatient.patientID,
      _id: this.props.currentPatient._id,
      phone: this.state.prevPatient.phone,
      email: this.state.prevPatient.email,
      nickname: this.state.prevPatient.nickname,
      gender: this.state.prevPatient.gender,
      prevPatient: null,
      emailPermission: emailPermission
    })
  }

  submit () {
    // Get the patient object ready to patch
    let patientInfo = {
      name: {
        given: this.state.firstName,
        middle: '',
        family: this.state.lastName,
        generational: ''
      },
      phone: this.state.phone,
      dob: moment(this.state.dob).format('YYYY-MM-DDTHH:mm:ss.SSSSZ'),
      email: this.state.email,
      gender: this.state.gender,
      nickname: this.state.nickname,
      emailPermission: {
        rideComplete: this.state.emailPermission.rideComplete,
        evalComplete: this.state.emailPermission.evalComplete,
      },
      _bundle: 'patient',
      _id: this.props.currentPatient._id
    }

    if (this.state.gender.length > 1) {
      patientInfo.gender = this.state.gender
    }

    this.props.updatePatient(patientInfo)
    this.setState({ prevPatient: null, editing: false })
  }

  render () {
    const { isVisible, theme } = this.props

    return (
      <div className={classNames('page patientProfile', !isVisible && 'shrink')}>
        <h2>Rider Profile</h2>

        <ValidatorForm
          className="patientProfileForm"
          onSubmit={() => {
            this.submit()
          }}
        >

          <div className="flexRow">
            <TextField
              inputlabelprops={{ shrink: true }}
              type="text"
              validators={['required']}
              required
              inputProps={{
                name: 'firstName'
              }}
              label="First Name"
              classes={{ root: 'form-group' }}
              value={this.state.firstName}
              onChange={(event) => {
                this.handleChange(event)
              }}
            />
            <TextField
              inputlabelprops={{ shrink: true }}
              type="text"
              validators={['required']}
              required
              inputProps={{
                name: 'lastName'
              }}
              label="Last Name"
              classes={{ root: 'form-group' }}
              value={this.state.lastName}
              onChange={(event) => {
                this.handleChange(event)
              }}
            />
          </div>

          <div className="flexRow">
            <TextField
              inputlabelprops={{ shrink: true }}
              type="text"
              inputProps={{
                name: 'nickname'
              }}
              label="Nickname"
              classes={{ root: 'form-group' }}
              value={this.state.nickname}
              onChange={(event) => {
                this.handleChange(event)
              }}
            />

            <FormControl className="form-group">
              <InputLabel htmlFor="gender">Gender</InputLabel>
              <Select
                inputlabelprops={{ shrink: true }}
                value={this.state.gender}
                onChange={(event) => {
                  this.handleChange(event)
                }}
                inputProps={{
                  id: 'gender',
                  name: 'gender'
                }}
              >
                <MenuItem value={''}></MenuItem>
                <MenuItem value={'male'}>Male</MenuItem>
                <MenuItem value={'female'}>Female</MenuItem>
              </Select>
            </FormControl>

          </div>

          <div className="flexRow">
            <TextField
              inputlabelprops={{ shrink: true }}
              type="date"
              required
              inputProps={{
                name: 'dob'
              }}
              label="Date of Birth"
              classes={{ root: 'form-group' }}
              value={moment(this.state.dob).format('YYYY-MM-DD')}
              onChange={(event) => {
                this.handleChange(event)
              }}
            />
            <TextField
              inputProps={{
                name: 'patientId',
                maxLength: 8
              }}
              disabled={!!this.state.patientId}
              inputlabelprops={{ shrink: true }}
              type="number"
              label="Rider ID"
              required
              classes={{ root: 'form-group' }}
              className={'disabled'}
              value={this.state.patientId}
              onChange={(event) => {
                this.handleChange(event)
              }}
            />
          </div>

          <div className="flexRow">
            <TextField
              inputlabelprops={{ shrink: true }}
              required
              type="email"
              validators={['required', 'isEmail']}
              inputProps={{
                name: 'email'
              }}
              label="Email Address"
              classes={{ root: 'form-group' }}
              value={this.state.email}
              onChange={(event) => {
                this.handleChange(event)
              }}
            />
            <TextField
              inputlabelprops={{ shrink: true }}
              required
              inputProps={{
                name: 'phone',
                type: 'tel',
              }}
              label="Phone"
              classes={{ root: 'form-group' }}
              value={this.state.phone}
              onChange={(event) => {
                this.handleChange(event)
              }}
            />
          </div>

          <h2>Email Preferences</h2>

          <div className="flexRow preferences">
            <Checkbox
              checked={this.state.emailPermission.rideComplete}
              name='rideComplete'
              onChange={(event) => {
                this.handleChange(event)
              }}
            />
            <p>Yes, I'd like to receive an email summary after AllCore360˚ rides</p>
          </div>

          <div className="flexRow preferences">
            <Checkbox
              checked={this.state.emailPermission.evalComplete}
              name='evalComplete'
              onChange={(event) => {
                this.handleChange(event)
              }}
            />
            <p>Yes, I'd like to receive an email summary after Core Evaluations</p>
          </div>

          {
            this.state.editing &&
            <footer className="flexRow">
              <Button onClick={this.cancelEdit} variant="contained" style={theme.button.secondary} className='button'>Cancel</Button>
              <Button type="submit" variant="contained" style={theme.button.primary} className="button">Save Changes</Button>
            </footer>
          }
        </ValidatorForm>

      </div>
    )
  }
}

export default compose(withStyles(styles, { withTheme: true }), connect(mapStateToProps, mapDispatchToProps))(PatientProfile)
